export const ISS_ACTION_TYPE = {
  KPP_ENTRY: 1,
  KPP_EXIT: 2,
  POT_ENTRY: 4,
  POT_EXIT: 5,
  PASSING: 6
}

export const ASTRA_ACTION_TYPE = {
  CARFLOW: 9,
  OVER_SPEED: 10,
  WRONG_DIRECTION: 11
}

export const VIDEOFOR_ACTION_TYPE = {
  ZONE_VIOLATION: 3,
  TRANSPORT_DETECTION: 41,
  TRANSPORT_DIRECTION: 42,
  TRANSPORT_ZONE_VIOLATION: 43,
  TRANSPORT_JAM: 44,
  TRANSPORT_ACCIDENT: 45,
  TIME_VIOLATION: 61,
  DANG_MOVE: 8
}

export const types = [
  {
    id: 'car_event',
    name: 'Телематика'
  },
  {
    id: 'gazprom',
    name: 'Камеры периметра АГПЗ (КПП, ЖД)'
  },
  {
    id: 'videophoto',
    name: 'Камеры ФВФ'
  },
  {
    id: 'videoanalytics',
    name: 'Камеры видеоаналитики'
  },
  {
    id: 'nipigaz_pot',
    name: 'Камеры ПОТ'
  },
  {
    id: 'nipigaz',
    name: 'Камеры дорожные'
  },
  {
    id: 'system_event',
    name: 'Системные'
  }
]

export const requestUrls = {
  car_event: {
    url: 'event_car_events',
    with_numeration: true,
    column_order: [
      'event_time',
      'event_type',
      'reg_number',
      'vehicle_model_name',
      'vehicle_type_name',
      'vehicle_type_group_name',
      'contractor_name',
      'sub_contractor_name',
      'speed_limit',
      'speed',
      'description'
    ],
    column_labels: [
      'Время события',
      'Тип события',
      'Гос. номер',
      'Модель',
      'Вид транспорта',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Разрешённая скорость',
      'Фактическая скорость',
      'Описание'
    ]
  },
  gazprom: {
    url: 'event_camera_traffic',
    with_numeration: true,
    column_order: [
      'reg_number',
      'vehicle.vehicle_type.vehicle_type_group.name',
      'vehicle.contractor.name',
      'vehicle.sub_contractor.name',
      'camera_name',
      'no_kpp',
      'time'
    ],
    column_labels: [
      'Гос. номер',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Камера',
      '№ КПП',
      'Время события'
    ]
  },
  videophoto: {
    url: 'event_camera_traffic',
    with_numeration: true,
    column_order: [
      'reg_number',
      'vehicle.model.name',
      'vehicle.vehicle_type.vehicle_type_group.name',
      'vehicle.contractor.name',
      'vehicle.sub_contractor.name',
      'vehicle.subprojects.name',
      'vehicle.project_label',
      'vehicle.applications.permits.number',
      'action_type',
      'camera_name',
      'time',
      'speed',
      'direction_id',
      'over_speed'
    ],
    column_labels: [
      'Гос. номер',
      'Модель',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Подпроект',
      'Проект',
      '№ пропуска',
      'Тип события',
      'Камера',
      'Время события',
      'Фактическая скорость, км/ч',
      'Направление',
      'Превышение, км/ч'
    ]
  },
  videoanalytics: {
    url: 'event_camera_traffic',
    with_numeration: true,
    column_order: [
      'action_type',
      'reg_number',
      'vehicle.vehicle_type.name',
      'vehicle.vehicle_type.vehicle_type_group.name',
      'vehicle.contractor.name',
      'vehicle.sub_contractor.name',
      'time'
    ],
    column_labels: [
      'Тип события',
      'Гос. номер',
      'Вид транспорта',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Время события'
    ]
  },
  nipigaz: {
    url: 'event_camera_traffic',
    with_numeration: true,
    column_order: [
      'reg_number',
      'vehicle.vehicle_type.vehicle_type_group.name',
      'vehicle.contractor.name',
      'vehicle.sub_contractor.name',
      'camera_name',
      'time'
    ],
    column_labels: [
      'Гос. номер',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Камера',
      'Время события'
    ]
  },
  nipigaz_pot: {
    url: 'event_camera_traffic',
    with_numeration: true,
    column_order: [
      'reg_number',
      'vehicle.vehicle_type.vehicle_type_group.name',
      'vehicle.contractor.name',
      'vehicle.sub_contractor.name',
      'camera_name',
      'time'
    ],
    column_labels: [
      'Гос. номер',
      'Тип транспорта',
      'Подрядчик',
      'Субподрядчик',
      'Камера',
      'Время события'
    ]
  },
  system_event: {
    url: 'event_system_events',
    with_numeration: true,
    column_order: [
      'end_time',
      'worker_class',
      'success'
    ],
    column_labels: [
      'Время события',
      'Тип события',
      'Статус'
    ]
  }
}

export const requestConfigs = {
  car_event: {
    only: ['id', 'event_time', 'event_type', 'event_geom', 'event_attrs', 'description'],
    order: [{ event_time: 'desc' }],
    include: {
      vehicle: {
        only: ['reg_number', 'id'],
        include: {
          model: {
            only: ['id', 'name']
          },
          vehicle_type: {
            only: ['id', 'name'],
            include: {
              vehicle_type_group: {
                only: ['name', 'id']
              }
            }
          },
          contractor: {
            only: ['id', 'name']
          },
          sub_contractor: {
            only: ['id', 'name']
          }
        }
      }
    }
  },
  gazprom: {
    where: [
      { field: 'camera_type', op: 'in', value: [2, 3] },
      {
        field: 'action_type',
        op: 'in',
        value: [
          ISS_ACTION_TYPE.KPP_ENTRY, ISS_ACTION_TYPE.KPP_EXIT]
      }
    ]
  },
  videophoto: {
    where: [
      { field: 'camera_type', op: '=', value: 1 }
    ]
  },
  videoanalytics: {
    where: [
      { field: 'camera_type', op: '=', value: 4 }
    ]
  },
  nipigaz: {
    where: [
      { field: 'camera_type', op: 'in', value: [2, 3] },
      { field: 'action_type', op: '=', value: ISS_ACTION_TYPE.PASSING }
    ]
  },
  nipigaz_pot: {
    where: [
      { field: 'camera_type', op: 'in', value: [2, 3] },
      {
        field: 'action_type',
        op: 'in',
        value: [
          ISS_ACTION_TYPE.POT_ENTRY, ISS_ACTION_TYPE.POT_EXIT
        ]
      }
    ]
  },
  system_event: {
    order: [{ end_time: 'desc' }]
  }
}
